import React, { useState } from 'react';
import MobileHeader from "../../layout/mobile/MobileHeader";
import MobileCarouselBanner from "../../sliders/Mobile";
import Announcement from "../../sliders/Mobile/Announcement";
import GameNavIcon from "../../navigation/mobile/GameNavIcon";
import Footer from "../../layout/mobile/Footer";
import ScrollBanner from "../../common/mobile/ScrollBanner";
import FeatureGames from "../../sliders/Mobile/FeatureGames";
import GuestToolbar from "../../layout/mobile/GuestToolbar";
import Toolbar from "../../navigation/mobile/Toolbar";
import Symbol from '../../common/mobile/Symbol.js';
import Logo from '../../common/mobile/Logo';



function Home({globalData}){
    const [isLoggedIn] = useState(!!localStorage.getItem('token'));
    const origin = window.location.hostname
    .replace(/^www\./, '')
    .replace(/\.(com|live|net|bet|buzz)$/i, '');
    return(
        <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
        <Symbol/>
    <div className="_container_box">
      <div className="home-container">
        <div className="home-header">
          <MobileHeader/>
        </div>
        <div id="mc-app-home-root">
          <div className="mc_app_box">
            <div className="banner_notice">
            <MobileCarouselBanner slidersMain={globalData.sliders?.main || []} /> 
              <div className="notice_root">
                <div className="notice_bg">
                  <svg className="am-icon am-icon-icon-speaker_66e380a0 am-icon-md notice_icon"><use xlinkHref="#icon-speaker_66e380a0" /></svg>
                  <div className="marquee">
                    <div className="marquee" style={{play: 'running', direction: 'normal', duration: '31.67109375s', delay: '0s', iterationCount: 'infinite'}}>
                      <div className="marquee_content">
                        <span className="content-item">একটি বিশাল 268% ডিপোজিট বোনাস পান!</span><span className="content-item">{origin} এ স্বাগতম</span>
                        <span className="content-item">অ্যাপ ডাউনলোড করুন এবং 888 টাকা জিতে নিন</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="home-content">
              <div className="game-enter-container">
                <div className="game-enter-content">
                  <GameNavIcon/>
                  <div className="game-content-wrap">
                    
                    <div className="home-footer">
                      {/* react-empty: 1804 */}
                      <FeatureGames 
                          slidersFavourite={globalData.sliders?.favourite || []} 
                          slidersFeatures={globalData.sliders?.feature || []} 
                      />
                      <Footer/>
                    </div>
                  </div>
                </div>
                <div className="go-top">
                  <svg className="am-icon am-icon-side-arrow-down_7d99edc7 am-icon-md">
                    <use xlinkHref="#side-arrow-down_7d99edc7" /></svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <footer className="app-win app-win-container-bg center" style={{bottom: '0px'}}>
            <div className="app-win-bg" />
            <span>
              <a className="mob-win" rel="nofollow me noopener noreferrer">
                <svg className="icon icon__android-down" viewBox="0 0 1024 1024" width={200} height={200}>
                  <defs><style dangerouslySetInnerHTML={{__html: "" }} /></defs>
                  <path d="M963.615 347.084q23.342 0 39.58 14.716t16.238 36.028v299.385q0 20.297-16.238 35.013t-39.58 14.716h-18.267q-23.342 0-39.58-14.716t-16.238-35.013V397.828q0-21.313 16.238-36.028t39.58-14.716h18.267zm-823.056 0q23.342 0 38.565 14.716t15.223 36.028v299.385q0 20.297-15.223 35.013t-38.565 14.716h-18.268q-23.342 0-39.58-14.716t-16.237-35.013V397.828q0-21.313 16.238-36.028t39.58-14.716h18.267zm560.206-235.449q18.268 8.12 38.058 22.327t38.057 33.49 31.968 42.118 19.79 48.206H252.194q16.238-53.788 51.251-88.293t70.533-54.803L322.22 33.49q-2.03-2.03-.507-7.61t10.656-11.672q8.119-7.104 15.223-6.597t9.133 2.538L409.5 93.368q28.416-13.194 59.877-20.298t64.951-7.104q69.011 0 128.888 28.417l53.788-84.234q2.03-2.03 7.611-2.03t16.746 6.09q10.148 5.073 11.67 9.133t-.507 6.09zm-283.148 87.279q13.194 0 22.327-9.134t9.134-22.327-9.134-22.327-22.327-9.134-22.327 9.134-9.133 22.327 9.133 22.327 22.327 9.134zm249.658-4.06q13.193 0 22.327-9.133t9.133-22.328-9.133-22.327-22.327-9.133-22.328 9.133-9.133 22.327 9.133 22.328 22.328 9.133zm161.363 126.859l1.015 456.69q0 22.326-14.715 37.55t-36.028 15.222h-14.208v142.082q0 20.297-14.716 35.52T713.958 1024h-29.43q-20.298 0-35.014-15.223t-14.715-35.52V831.175H448.063v142.082q0 20.297-14.715 35.52T397.32 1024h-29.43q-20.297 0-35.013-15.223t-14.715-35.52V831.175h-11.164q-21.312 0-36.028-15.223t-14.715-37.55v-456.69h572.384z" />
                </svg>
                {/* react-text: 2495 */}Android APP{/* /react-text */}
              </a>
            </span>
            <span className="app-close"><b className="clear-left" /><b className="clear-right" /></span>
          </footer>
          {/* react-empty: 2500 */}
        </div>
        {/* react-empty: 2358 */}{/* react-empty: 2359 */}
        <div className="common-popup-container">{/* react-empty: 2361 */}{/* react-empty: 2362 */}</div>
        <div className="common-popup-container">{/* react-empty: 2364 */}{/* react-empty: 2365 */}</div>
        <div id="this_home_bg" className="home" />
      </div>
      {isLoggedIn ? (
                   <Toolbar/>
                ) : (
                    <GuestToolbar/>
                )}
      
      
    </div>
  </div>
      
    );


}
export default Home;
